import React from "react";
import { observer } from "mobx-react";
import { CurrencyViewStore } from "../../store";
import { CurrencyViewForm } from "./CurrencyViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type CurrencyViewProps = {
  currencyViewStore: CurrencyViewStore;
};

export const CurrencyView: React.FC<CurrencyViewProps> = observer(
  ({ currencyViewStore }) => {
    return (
      <div>
        <CurrencyViewForm
          code={currencyViewStore.codeValue}
          name={currencyViewStore.nameValue}
          onPrint={(handlePrint: () => void) =>
            currencyViewStore.printCurrency(handlePrint)
          }
          onCancel={() => currencyViewStore.cancelCurrency()}
          onEdit={
            currencyViewStore.isEditEnabled
              ? () => currencyViewStore.editCurrency()
              : undefined
          }
        />
        <ErrorDialog
          open={currencyViewStore.errorDialogOpened}
          title={currencyViewStore.errorTitle}
          description={currencyViewStore.errorDescription}
          onClose={() => currencyViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
